import { colonyAPI, facebookAPI, instagramAPI, tiktokAPI } from '@/api';

import * as types from './mutation-types';

export default {
  getChannels({ commit }) {
    commit(types.GET_CHANNELS_REQUEST);
    colonyAPI
      .get('campaigns/channels/')
      .then(response => commit(types.GET_CHANNELS_SUCCESS, response))
      .catch(error => commit(types.GET_CHANNELS_FAILURE, error));
  },

  getChannelLinks({ commit, rootState }, campaign) {
    commit(types.GET_CHANNEL_LINKS_REQUEST);
    const params = { cache: 60000, campaign };
    colonyAPI
      .get('campaigns/channels/links/', { params })
      .then(response => commit(types.GET_CHANNEL_LINKS_SUCCESS, { rootState, campaign, response }))
      .catch(error => commit(types.GET_CHANNEL_LINKS_FAILURE, error));
  },

  addTwitterChannel({ dispatch }, uid) {
    const addChannelWindow = window.open(
      `${process.env.API_COLONY}campaign/channel/twitter/login?userid=${uid}`,
      'ColonyLive twitter Auth',
      'status=1,resizable=1,scrollbars=1,width=500,height=550',
    );

    dispatch('isPopUpBlocked', addChannelWindow);
  },

  addTikTokChannel({ dispatch }, uid) {
    const addChannelWindow = window.open(
      `${process.env.API_COLONY}campaign/channel/tiktok/login?userid=${uid}`,
      'ColonyLive tiktok Auth',
      'status=1,resizable=1,scrollbars=1,width=500,height=550',
    );

    dispatch('isPopUpBlocked', addChannelWindow);
  },

  getFacebookPages({ commit }) {
    commit(types.GET_FACEBOOK_PAGES_REQUEST);

    return facebookAPI
      .get('/userpages/')
      .then(response => commit(types.GET_FACEBOOK_PAGES_SUCCESS, response.data))
      .catch(error => commit(types.GET_FACEBOOK_PAGES_FAILURE, error));
  },

  getInstagramPages({ commit }, user) {
    commit(types.GET_INSTAGRAM_PAGES_REQUEST);

    return instagramAPI
      .get('/facebook/userpages/', { params: { user_id: user.id } })
      .then(response => commit(types.GET_INSTAGRAM_PAGES_SUCCESS, response.data))
      .catch(error => commit(types.GET_INSTAGRAM_PAGES_FAILURE, error));
  },

  addFacebookChannelAuth({ commit, dispatch }) {
    const token = localStorage.getItem('token');
    const addChannelWindow = window.open(
      `${process.env.API_COLONY}campaign/channel/facebook/login/?token=${token}`,
      'Facebook Channel Service',
      'width=650px,height=600px',
    );

    const canShowDialog = dispatch('isPopUpBlocked', addChannelWindow).then(isPopUpBlocked => {
      if (!isPopUpBlocked) {
        commit(
          types.POLL_FACEBOOK_PAGES_START,
          setInterval(() => {
            dispatch('channel/getFacebookPages', null, { root: true });
          }, 2 * 1000),
        );
      }
      return !isPopUpBlocked;
    });
    return canShowDialog;
  },

  addInstagramChannelAuth({ commit, dispatch }, user) {
    const addChannelWindow = window.open(
      `${process.env.API_INSTAGRAM}/facebook/login/?user_id=${user.id}&company_id=${
      user.use_as_company
      }`,
      'Instagram Channel Service',
      'width=500,height=300',
    );
    const canShowDialog = dispatch('isPopUpBlocked', addChannelWindow).then(isPopUpBlocked => {
      if (!isPopUpBlocked) {
        commit(
          types.POLL_INSTAGRAM_PAGES_START,
          setInterval(() => {
            dispatch('channel/getInstagramPages', user, { root: true });
          }, 2 * 1000),
        );
      }
      return !isPopUpBlocked;
    });
    return canShowDialog;
  },

  addFacebookPage({ commit, dispatch }, pageId) {
    commit(types.ADD_FACEBOOK_PAGE_REQUEST);

    return facebookAPI
      .get('/createchannel/', { params: { page_id: pageId } })
      .then(resp => commit(types.ADD_FACEBOOK_PAGE_SUCCESS, resp.data))
      .then(() => dispatch('channel/getChannels', null, { root: true }))
      .catch(error => commit(types.ADD_FACEBOOK_PAGE_FAILURE, error));
  },

  addInstagramPage({ commit }, [userId, pageId]) {
    commit(types.ADD_INSTAGRAM_PAGE_REQUEST);

    return instagramAPI
      .get('facebook/create/', { params: { user_id: userId, page_id: pageId } })
      .then(resp => commit(types.ADD_INSTAGRAM_PAGE_SUCCESS, resp.data))
      .catch(error => commit(types.ADD_INSTAGRAM_PAGE_FAILURE, error));
  },

  addEmailChannel({ commit }, payload) {
    commit(types.ADD_EMAIL_CHANNEL_REQUEST);

    return colonyAPI
      .post('campaigns/channels/', payload)
      .then(commit(types.ADD_EMAIL_CHANNEL_DONE))
      .catch(commit(types.ADD_EMAIL_CHANNEL_DONE));
  },

  addWechatChannel({ commit }, payload) {
    commit(types.ADD_WECHAT_CHANNEL_REQUEST);

    return colonyAPI
      .post('campaigns/channels/', payload)
      .then(commit(types.ADD_WECHAT_CHANNEL_DONE))
      .catch(commit(types.ADD_WECHAT_CHANNEL_DONE));
  },

  getWhatsAppAuthCode({ commit }, payload) {
    commit(types.GET_WHATSAPP_AUTH_CODE_REQUEST);
    const url = `campaigns/channels/whatsapp/sms-code/?cc=${payload.cc}&phone=${payload.phone}`;
    return colonyAPI
      .get(url)
      .then(commit(types.GET_WHATSAPP_AUTH_CODE_SUCCESS))
      .catch(commit(types.GET_WHATSAPP_AUTH_CODE_FAILURE));
  },

  addwhatsappChannel({ commit, dispatch }, payload) {
    commit(types.ADD_WHATSAPP_CHANNEL_REQUEST);
    colonyAPI
      .post('campaigns/channels/whatsapp/add-account/', payload)
      .then(response => {
        const createChannelPayload = {
          handle: payload.cc + payload.phoneNumber,
          extra_data: {
            login: response.data.login,
            pw: response.data.pw,
          },
        };
        colonyAPI
          .post('campaigns/channels/', createChannelPayload)
          .then(commit(types.ADD_WHATSAPP_CHANNEL_SUCCESS))
          .catch(commit(types.ADD_WHATSAPP_CHANNEL_FAILURE));
      })
      .catch(commit(types.ADD_WHATSAPP_CHANNEL_FAILURE));
  },

  isPopUpBlocked({ dispatch }, popUpWindow) {
    if (popUpWindow === null) {
      dispatch('toast/error', 'Disable your pop-up blocker then try again.', { root: true });
      return true;
    }
    return false;
  },

  updateChannel({ commit, dispatch }, channel) {
    commit(types.UPDATE_CHANNEL_REQUEST);

    return colonyAPI
      .put(`campaigns/channels/${channel.id}/`, channel)
      .then(() => dispatch('channel/updateChannelSuccess', channel, { root: true }))
      .catch(() => dispatch('channel/updateChannelFailed', channel, { root: true }));
  },

  updateChannelSuccess({ commit, dispatch }, channel) {
    commit(types.UPDATE_CHANNEL_SUCCESS);
    dispatch('channel/getChannels', null, { root: true });
    dispatch('toast/success', `${channel.handle} updated successfully.`, { root: true });
  },

  updateChannelFailed({ commit, dispatch }, channel) {
    commit(types.UPDATE_CHANNEL_FAILURE);
    dispatch('toast/error', `Unable to update channel ${channel.handle}.`, { root: true });
  },

  getTiktokCreatorInfo({ commit }, { channel_handle, company_id }) {
    commit(types.GET_TIKTOK_CREATOR_INFO_REQUEST);

    return tiktokAPI
      .post('/auth-tiktok/creator-info/', { channel_handle, company_id })
      .then(response => {
        commit(types.GET_TIKTOK_CREATOR_INFO_SUCCESS, response.data);
        return response.data;
      })
      .catch(error => {
        commit(types.GET_TIKTOK_CREATOR_INFO_FAILURE, error);
        throw error;
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/channel/actions.js